import React from 'react';
import useManual from 'containers/Admin/OnlineOrdersManual/useManual';
import ButtonComponent from 'components/ButtonComponent';

const DownloadManual = () => {
    const { manualExists } = useManual();

    const handleManualDownload = () => {
        const link = document.createElement('a');
        link.href = '/storage/orders_manual_current.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <h2>Wyświetl instrukcję obsługi zamówień online</h2>
            <div className='DownloadManual-container'>
                <ButtonComponent
                    text='Pokaż instrukcję'
                    onClick={handleManualDownload}
                    variant='primary'
                    margin='0.25rem'
                    height='37px'
                    onHoverAnimation={1}
                    disabled={!manualExists}
                />
            </div>
        </>
    );
};

export default DownloadManual;
